import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import { LinkLabel } from '../../../types/CommonVM';
import { getFooterText } from '../../domain/store/FooterStore';
import styles from '../styles/Footer.module.scss';

interface FooterSocialMediaCmpProps {
  socialMediaLinks?: LinkLabel[];
}

function FooterSocialMediaCmp({
  socialMediaLinks,
}: Readonly<FooterSocialMediaCmpProps>): React.ReactElement {
  const { locale } = useRouter();
  const { followUs } = useMemo(() => getFooterText(locale), [locale]);

  return (
    <div className={styles['social-media-container']}>
      <div className={styles['footer-brand-heading']}>{followUs}</div>
      <div className={styles['social-media']}>
        {socialMediaLinks ? (
          socialMediaLinks.map(link => (
            <a
              className={styles[link.label]}
              key={link.label}
              href={link.link}
              target="_blank"
              rel="noreferrer"
              aria-label={link.label}
            />
          ))
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

export default FooterSocialMediaCmp;
